import { ExtensionsType } from 'entities/Extensions/types';
import { CategoryTypeEnum } from 'entities/Files/types';

export enum FeaturesEnum {
	NEURAL_MODEL = 'neural-models',
	RESELLER = 'reseller',
	INBOUND_EMAIL = 'inbound-email',
	PASSWORD_ROTATION = 'password-rotation',
}

export enum DefaultExportType {
	JSON = 'JSON',
	XLSX = 'XLSX',
	CSV = 'CSV',
	XML = 'XML',
	XLS = 'XLS',
}

export enum DefaultExportDestination {
	DIRECT = 'DIRECT',
	FTP = 'FTP',
}

export enum EReplacementOption {
	UNDERSCORE = '_',
	DASH = '-',
	SPACE = ' ',
	REMOVE = '',
}

export type AdditionalFeatureType = {
	feature: FeaturesEnum;
	isEnabled: boolean;
	neuralModelsLimit?: number;
};

export type DefaultExport = {
	defaultType: DefaultExportType;
	defaultDestination: DefaultExportDestination;
	replacementSettings: {
		replaceSpecialCharacters: string[];
		replacementOption: EReplacementOption;
	};
	unzip: boolean;
};

export type DefaultImportModels = {
	category: CategoryTypeEnum;
	pagesRange: string;
	customModelId?: string;
	generativeModelId?: string;
};

export type DefaultImport = {
	pagesSettings: {
		isEnabled: boolean;
		models: DefaultImportModels[];
	};
};

export type Company = {
	_id: string;
	userId: string;
	name: string;
	address: {
		country: string;
		city: string;
		street: string;
		houseNumber: string;
		postalCode: string;
	};
	taxInfo: {
		vatNumber: string;
		sdiCode: string;
	};
	additionalFeatures: AdditionalFeatureType[];
	extensions: ExtensionsType[];
	defaultExport: DefaultExport;
	defaultImport: DefaultImport;
	autoConnectPartners: {
		isEnabled: boolean;
		matchByCustomerName: boolean;
		matchByEmail: boolean;
	};
	createdAt: string;
	updatedAt: string;
	metadata?: {
		isSichim: boolean;
		ediFormatCustomModelId?: string;
		edilDeltaCustomModelId?: string;
		teknomegaEdiModelIds?: string[];
		isVelamp?: boolean;
		allowGenerativeModelsSandbox?: boolean;
		faterModelIds?: string[];
	};
};

export type CompanyForRequest = {
	name: Company['name'];
	country: Company['address']['country'];
	city: Company['address']['city'];
	street: Company['address']['street'];
	houseNumber: Company['address']['houseNumber'];
	postalCode: Company['address']['postalCode'];
	vatNumber: Company['taxInfo']['vatNumber'];
	sdiCode: Company['taxInfo']['sdiCode'];
};
